import { components } from 'react-select';

const MenuListWithFooter = ({ children, selectProps, ...rest }) => {
  return (
    <components.MenuList {...rest} selectProps={selectProps}>
      {children}
      <div className='block' style={{ position: 'sticky', bottom: 0, background: 'white' }}>
        <a className='button secondary naked' onClick={selectProps.handleCreateNew} href={selectProps.redirectUrl}>
          <SvgIconsPlus /> {selectProps.createNewText || 'Create new'}
        </a>
      </div>
    </components.MenuList>
  );
};

export default MenuListWithFooter
